import React, { useContext, useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { EstimationItem } from './estimation-item';
import { PerformanceShimmer } from './performance-shimmer';
import { getPerformanceTileStyle } from './styles/get-performance-tile-styles';

export function PerformanceTile(props) {
  const {
    className,
    heading,
    description,
    note,
    noEstimatesDescription,
    estimations,
    showShimmer,
    isDisplayPlusCampaign,
  } = props;
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getPerformanceTileStyle);

  const hasEstimations = estimations && estimations.length > 0;

  const performanceItemList = useMemo(() => {
    if (!hasEstimations) {
      return (
        <div className="no-performance-view">
          {noEstimatesDescription || i18n.getString(_TL_('No estimates available right now.'))}
        </div>
      );
    }

    return estimations.map(config => (
      <EstimationItem
        key={config.title}
        className={config.className}
        title={config.title}
        dashColor={config.dashColor}
        estimation={config.estimation}
        isDisplayPlusCampaign={isDisplayPlusCampaign}
      />
    ));
  }, [estimations, hasEstimations, i18n, isDisplayPlusCampaign, noEstimatesDescription]);

  return (
    <div className={classNames('performance-tile-container', classes.performanceTileContainer, className)}>
      <div className="performance-tile">
        <h2 className="performance-heading">
          {heading}
        </h2>
        {description && (showShimmer || hasEstimations) &&
          <div className="performance-description">
            {description}
          </div>
        }
        <div className="performance-status" role="status">
          {showShimmer ? <PerformanceShimmer /> : performanceItemList}
        </div>
      </div>
      {note && (showShimmer || hasEstimations) &&
        <div className="performance-note">
          {note}
        </div>
      }
    </div>
  );
}

PerformanceTile.propTypes = {
  className: PropTypes.string,
  heading: PropTypes.string.isRequired,
  description: PropTypes.string,
  note: PropTypes.string,
  noEstimatesDescription: PropTypes.string,
  estimations: PropTypes.arrayOf(PropTypes.shape({
    className: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    dashColor: PropTypes.string.isRequired,
    estimation: PropTypes.oneOfType([
      PropTypes.number,
      PropTypes.arrayOf(PropTypes.number),
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.string),
    ]).isRequired,
  })),
  showShimmer: PropTypes.bool.isRequired,
};

PerformanceTile.defaultProps = {
  className: '',
  description: '',
  note: '',
  noEstimatesDescription: '',
  estimations: [],
};

